import { useMemo } from "react";

import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

interface UseSupplierShipmentETAsProps {
  shipmentId: number;
}

export function useSupplierShipmentETAs(props: UseSupplierShipmentETAsProps) {
  const { shipmentId } = props;
  const { role } = useRoleContext();

  const url = useMemo(() => {
    if (role?.id && shipmentId) {
      return `/shippers/${role.id}/supplier-shipments/${shipmentId}/etas`;
    }
    return null;
  }, [role?.id, shipmentId]);

  const {
    data: etas,
    loading,
    error,
    refetch: refetchETAs,
  } = useSwrFetch<RoutePointETA[]>({
    url,
    errorMessage: "Failed to fetch supplier shipment ETAs",
  });

  return {
    etas: etas ?? null,
    loading,
    error,
    refetchETAs,
  };
}
